import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { MeasuresScreen } from "../../screens/measures/MeasuresScreen.tsx";

/** `/measures`: every tracked measure, the ones that need a look first. */
export const Route = createFileRoute("/_app/measures/")({
  loader: ({ context }) => context.queryClient.prefetchQuery(actions.queryOptions("measures.list", {})),
  component: MeasuresScreen,
});
